/**
 * Labstep
 *
 * @module components/Metadata/Detail/Table/Settings
 * @desc Metadata Detail Settings
 */

import { EntityDetailTable } from 'labstep-web/components/Entity/Detail/Table';
import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import type React from 'react';
import type { MetadataDetailTableSettingsProps } from './types';
import { getRows } from './utils';

export const MetadataDetailTableSettings: React.FC<
  MetadataDetailTableSettingsProps
> = ({ metadata, entity, activeGroup }) => (
  <EntityDetailTable
    rows={getRows(entity, metadata, activeGroup?.id)}
    columns={[metadata]}
  />
);

export default withActiveGroup(MetadataDetailTableSettings);
